import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { IMember } from '../../models/member';
import { ISession } from '../../models/session';
import { DistributeService } from '../../services/distribute.service';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-sessions-tab',
  templateUrl: './sessions-tab.component.html',
  styleUrls: ['./sessions-tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SessionsTabComponent extends BaseComponent implements OnInit {
  selectedSession: ISession = null;
  selectedIndex: number;
  selectedId: any;
  sessions!: ISession[];

  @Output() isValid = new EventEmitter<boolean>();

  trackByFn(i: number, itm: ISession) {
    return itm.id ?? i;
  }

  constructor(private distributeService: DistributeService) {
    super();
  }

  ngOnInit(): void {
    this._getSessions();
  }

  private _getSessions() {
    this.distributeService
      .getSessionsByVisitKey(this.visitInfo.key)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.sessions = res;
        this.isValid.emit(this._checkIfSessionsIsValid());
      });
  }

  selectSession([id]) {
    const index = this.sessions.findIndex((d) => d.id === id);
    this.selectedIndex = index;
    this.selectedSession = this.sessions[this.selectedIndex];
  }

  targetChanges(event: IMember[]) {
    const data = {
      ...this.selectedSession,
      visitMembers: event,
    };

    this.distributeService
      .updateSessionMembers(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.selectedSession = res;
        this.sessions[this.selectedIndex].visitMembers = res.visitMembers;
        this.isValid.emit(this._checkIfSessionsIsValid());
      });
  }

  private _checkIfSessionsIsValid() {
    return this.sessions.every((data) => !!data?.visitMembers?.length);
  }
}
